import {
    GET_OPERATOR_FLEET_DETAIL_START,
    GET_OPERATOR_FLEET_DETAIL_SUCCESS,
    GET_OPERATOR_FLEET_DETAIL_ERROR,
    DOCUMENT_EXPIRED_START,
    DOCUMENT_EXPIRED_SUCCESS,
    DOCUMENT_EXPIRED_ERROR
} from '../Constants/OperatorFleetDetailConstant'
  
const initialState = {
    loading: false,
    operatorFleetDetail: [],
    expiredData : []
};
  
export default function OperatorFleetDetailReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case GET_OPERATOR_FLEET_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case GET_OPERATOR_FLEET_DETAIL_SUCCESS:
        return {
          ...state,
          operatorFleetDetail: action.payload,
          loading: false,
        };
      case GET_OPERATOR_FLEET_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case DOCUMENT_EXPIRED_START:
        return {
          ...state,
          loading: true,
        };
      case DOCUMENT_EXPIRED_SUCCESS:
        return {
          ...state,
          expiredData: action.payload,
          loading: false,
        };
      case DOCUMENT_EXPIRED_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
    
      default:
        return state;
    }
}
  